import Body from "./components/Body";

function App() {
  return (
    <div className="text-xl ">
      <Body />
    </div>
  );
}

export default App;
